const SET_PERMISSIONS = 'SET_PERMISSIONS';
const SET_CURRENT_LANG = 'SET_CURRENT_LANG';

export default {
    namespaced: true,
    state: {
        permissions: {},
        currentLang: '',
    },
    mutations: {
        [SET_PERMISSIONS](state, value) {
            state.permissions = value;
        },
        [SET_CURRENT_LANG](state, value) {
            state.currentLang = value;
        },
    },
    getters: {
        permissions: state => state.permissions,
        currentLang: state => state.currentLang,
    },
    actions: {
        setPermissions({ commit }, val) {
            commit(SET_PERMISSIONS, val);
        },
        setCurrentLang({ commit }, val) {
            commit(SET_CURRENT_LANG, val);
        },
    }
};
